import './index.css';
import { useInView, motion } from 'framer-motion';
import { useRef } from 'react';
import { slideUp } from './animation';
import Container from '../Container/Index';
import Title from '../../components/Title/Index'
import { Link } from 'react-router-dom';

const Index = ({Data}) => {
    const description = useRef(null);
    const isInView = useInView(description);
    
    return (
        <>
            <Container _parentClass='Overview py-lg-5 py-0' containerClass={'position-relative'}>
                        <div ref={description} className="description col-lg-11 col-12 m-auto">
                        <div className="row body">
                                <div className='col-lg-6 col-12'>
                                    <Title firstHeading={Data.heading} secondHeading={Data.title} _class={'px-sm-2 mb-lg-0 mb-3 px-0 text-start heightBorder position-relative'} headingOne={true} _secondHeading={'position-relative'}/>
                                </div>
                                <div className='col-lg-6  col-12 position-relative'>
                                <p className='m-0 position-relative'>
                                    {Data.overview[0].split(" ").map((word, index) => (
                                        <span key={index} className="mask">
                                            <motion.span 
                                                variants={slideUp} 
                                                custom={index} 
                                                animate={isInView ? "open" : "closed"} 
                                                key={index}
                                            >
                                                {word}
                                            </motion.span>
                                        </span>
                                    ))}
                                </p>
                                
                                <div className='col-12 float-start' data-aos="fade-up" data-aos-offset="100" data-aos-duration="500" data-aos-once="true" data-aos-easing="ease-in-sine">
                                  <Link to='/about-arsus-global'><span className='customButton'>Know More</span></Link>
                                </div>
                                </div>
                            </div>
                        </div>
            </Container>

        </>
    );
}

export default Index;
